import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../globals'
import { ILockStatus } from '../../Models/ILockStatus';
import { Message, SelectItem } from 'primeng/primeng';
import { Router } from "@angular/router";
import { AdminPlacementService } from "../../Services/AdminPlacementService";
import { LookupService } from 'src/app/Services/LookupService';
import { DashboardDocumentService } from 'src/app/Services/DashboardDocumentService';
import { StudentService } from 'src/app/Services/StudentService';
import { ReportService } from 'src/app/Services/ReportService';
import { SpinnerBase } from '../Base/SpinnerBase';
import { IDashboardDocument } from '../../Models/IDashboardDocument'
import { ISpedStudentDemographics } from '../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../Models/IIepInstance'
import { ILookupBase } from '../../Models/ILookupBase';
import { IIepServiceInfo } from '../../Models//IIepServiceInfo';
import { LookupTypeEnum } from 'src/app/Models/Enums/LookupTypeEnum';
import { IAdminPlacement } from "../../Models/IAdminPlacement"
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { ISelectedStudent } from 'src/app/Models/ISelectedStudent';

@Component({
  selector: 'AdminPlacement',
  templateUrl: './AdminPlacement.component.html',
})
export class AdminPlacementComponent extends SpinnerBase implements OnInit {
  _myGlobals: Globals;
  _baseUrl: string;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  passedPrintSignatureValidation: boolean = false;
  isLocked: boolean;
  lockStatus: string;
  canEditIep: boolean;
  saveClicked: boolean;
  adminPlacementDB: any = [];
  isDataLoaded: boolean = false;
  _lookupService: LookupService;
  _dashboardDocumentService: DashboardDocumentService;
  _studentService: StudentService;
  lookupDisabilityList: ILookupBase[];
  lookupDegreeOfSupportList: SelectItem[];
  lookupServiceList: ILookupBase[];
  spedServiceList: ILookupBase[];
  spedServiceListIncludeDisabled: ILookupBase[];
  lookupServiceDurationList: ILookupBase[];
  lookupServiceLocationList: ILookupBase[];
  lookupServiceLocationListWithDisabled: ILookupBase[];
  lookupServiceFrequencyList: ILookupBase[];
  lookupServiceIndividualGroupList: ILookupBase[];
  lookupServiceIndividualGroupListWithDisabled: ILookupBase[];
  parentGuardianList: ILookupBase[];
  howVerifiedList: ILookupBase[];
  calpadsMeetingTypeList: ILookupBase[];
  lookupCurriculumList: ILookupBase[];
  services: IIepServiceInfo[];
  newAttribute: IIepServiceInfo;
  rowNum: number;
  showSpinner: boolean = false;
  reportParamArray: IReportParameter[];
  requireDegreeOfSupportServiceList: string[];
  serviceStartDate: Date;
  serviceEndDate: Date;
  showPreviousIepInfo: boolean = false;
  dateThreeYearsBack: Date;
  dateFiveYearsBack: Date;
  dateSevenYearsBack: Date;
  dateTenYearsBack: Date;
  dateThreeYearsForward: Date;
  dateOneYearBack: Date;
  dateOneYearForward: Date;
  rangeFiveYearsBack: string;
  rangeFiveYearsBackOneForward: string;
  rangeFiveYearsBackThreeForward: string;
  rangeSevenYearsBack: string;
  rangeTenYearsBack: string;
  rangeTenYearsBackOneForward: string;
  rangeTenYearsBackThreeForward: string;
  _spinnerWhileMessage: string;
  _aeriesRefreshSpinnerMessage: string;
  _validateSpinnerMessage: string;
  showRefreshSpinner: boolean;
  showPushInPullOut: boolean;

  constructor(
    private globals: Globals,
    reportService: ReportService,
    @Inject('BASE_URL') baseUrl: string,
    public router: Router,
    lookupService: LookupService,
    studentService: StudentService,
    dashboardDocumentService: DashboardDocumentService,
    private _adminPlacementService: AdminPlacementService) {
    super(reportService);
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
    this._lookupService = lookupService;
    this._studentService = studentService;
    this._dashboardDocumentService = dashboardDocumentService;
  }

  ngOnInit(): void {
    this.buildRequiredDisabiltiyList();
    this.LoadAdminPlacementDetails();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.serviceStartDate = new Date();
    this.serviceEndDate = new Date();
    this.serviceEndDate.setDate(this.serviceStartDate.getDate() + parseInt('29'));
    this.errorMessages = [];
    let today = this._myGlobals.todaysDate;
    this.dateThreeYearsBack = new Date(today.getFullYear() - 3, today.getMonth(), today.getDate());
    this.dateThreeYearsForward = new Date(today.getFullYear() + 3, today.getMonth(), today.getDate());
    this.dateFiveYearsBack = new Date(today.getFullYear() - 5, today.getMonth(), today.getDate());
    this.dateSevenYearsBack = new Date(today.getFullYear() - 7, today.getMonth(), today.getDate());
    this.dateTenYearsBack = new Date(today.getFullYear() - 10, today.getMonth(), today.getDate());
    this.dateOneYearBack = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate());
    this.dateOneYearForward = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate());
    this.rangeFiveYearsBack = this.dateFiveYearsBack.getFullYear() + ':' + today.getFullYear();
    this.rangeSevenYearsBack = this.dateSevenYearsBack.getFullYear() + ':' + today.getFullYear();
    this.rangeTenYearsBack = this.dateTenYearsBack.getFullYear() + ':' + today.getFullYear();
    this.rangeFiveYearsBackOneForward = this.dateFiveYearsBack.getFullYear() + ':' + (today.getFullYear() + 1);
    this.rangeFiveYearsBackThreeForward = this.dateFiveYearsBack.getFullYear() + ':' + this.dateThreeYearsForward.getFullYear();
    this.rangeTenYearsBackOneForward = this.dateTenYearsBack.getFullYear() + ':' + (today.getFullYear() + 1);
    this.rangeTenYearsBackThreeForward = this.dateFiveYearsBack.getFullYear() + ':' + this.dateThreeYearsForward.getFullYear();
    this.passedPrintSignatureValidation = false;
  }

  buildRequiredDisabiltiyList() {
    this.requireDegreeOfSupportServiceList = ['210', '260', '270', '280', '290', '300', '310', '320', '330', '331', '332'];
  }

  LoadAdminPlacementDetails(): void {
    this.showSpinner = true;
    this.isDataLoaded = false;
    if (this._myGlobals.selectedDashboardDocument.adminPlacementId != null) {   
    this._adminPlacementService.getAdminPlacement(this._myGlobals.selectedDashboardDocument.adminPlacementId)
      .subscribe((res: IAdminPlacement) => {
        this.adminPlacementDB = res as IAdminPlacement;
        this.serviceStartDate = new Date(res.meetingDate);
        this.serviceEndDate = new Date(res.iepMeetingToBeConducted30DaysBy);
        this.adminPlacementDB.meetingDate = this.adminPlacementDB.meetingDate == null ? null : new Date(this.adminPlacementDB.meetingDate);
        this.adminPlacementDB.annualDue = this.adminPlacementDB.annualDue == null ? null : new Date(this.adminPlacementDB.annualDue);
        this.adminPlacementDB.lastAnnualDate = this.adminPlacementDB.lastAnnualDate == null ? null : new Date(this.adminPlacementDB.lastAnnualDate);
        this.adminPlacementDB.lastTriennial = this.adminPlacementDB.lastTriennial == null ? null : new Date(this.adminPlacementDB.lastTriennial);
        this.adminPlacementDB.amendsIEPSpecialEdMeetingDate = this.adminPlacementDB.amendsIEPSpecialEdMeetingDate == null ? null : new Date(this.adminPlacementDB.amendsIEPSpecialEdMeetingDate);
        this.adminPlacementDB.participantsAdministratorDesigneeDate = this.adminPlacementDB.participantsAdministratorDesigneeDate == null ? null : new Date(this.adminPlacementDB.participantsAdministratorDesigneeDate);
        this.adminPlacementDB.participantsOtherDate = this.adminPlacementDB.participantsOtherDate == null ? null : new Date(this.adminPlacementDB.participantsOtherDate);
        this.adminPlacementDB.participantsParentGuardianDate = this.adminPlacementDB.participantsParentGuardianDate == null ? null : new Date(this.adminPlacementDB.participantsParentGuardianDate);
        this.adminPlacementDB.participantsTeacherDate = this.adminPlacementDB.participantsTeacherDate == null ? null : new Date(this.adminPlacementDB.participantsTeacherDate);
        this.adminPlacementDB.triDueDate = this.adminPlacementDB.triDueDate == null ? null : new Date(this.adminPlacementDB.triDueDate);
        this.adminPlacementDB.verifiedDate = this.adminPlacementDB.verifiedDate == null ? null : new Date(this.adminPlacementDB.verifiedDate);
        this.adminPlacementDB.howVerifiedId = this.adminPlacementDB.howVerifiedId == null ? null : this.adminPlacementDB.howVerifiedId.toString();
        this.adminPlacementDB.amendsIEPSpecialEdPlanTypeCode = '100';
        this.LoadLookupValues();

        //convert date strings into local time datestrings
        if (this.adminPlacementDB.spedStudentDemographic) {
          this.adminPlacementDB.spedStudentDemographic.dob = new Date(this.adminPlacementDB.spedStudentDemographic.dob);
          this.adminPlacementDB.spedStudentDemographic.meetingDate = new Date(this.adminPlacementDB.spedStudentDemographic.meetingDate);
        }

        //LoadServicesValues
        this.rowNum = 1;

        if (res == null || res.serviceInformationList == null) {
          let message = 'No services found';
        }
        else {
          this.services = res.serviceInformationList.map(o => {
            return {
              id: o.id,
              localStudentId: o.localStudentId,
              serviceId: o.starSpecialEducationService_Id?.toString(),
              duration: o.duration?.toString(),
              location: o.location?.toString(),
              frequency: o.frequency?.toString(),
              individualGroup: o.individualGroup?.toString(),
              pushInPullOut: o.pushInPullOut,
              startDate: o.startDate == null ? new Date(this.serviceStartDate) : o.startDate,
              endDate: o.endDate == null ? null : o.endDate,
              removed: o.removed,
              offerOfFapeStartDate: o.offerOfFapeStartDate == null ? this.serviceStartDate : o.offerOfFapeStartDate,
              offerOfFapeEndDate: o.offerOfFapeEndDate == null ? this.serviceEndDate : o.offerOfFapeEndDate,
              offerOfFapeEndDateString: o.offerOfFapeEndDateString == null ? this.serviceEndDate.toLocaleDateString() : o.offerOfFapeEndDateString,
              serviceDuration: o.serviceDuration,
              sortOrder: o.sortOrder,
              starIepPage1_Id: o.starIepPage1_Id,
              iPAddress: o.iPAddress,
              updatedOn: o.updatedOn,
              rowNumber: this.rowNum++,
            };
          });
        }

        let servicesWithPushInPullOutList = this.services.filter(x => x.pushInPullOut)
        if (this.services && this.services.length > 0 && servicesWithPushInPullOutList.length > 0) {
          this.showPushInPullOut = true;
        }
        else {
          this.showPushInPullOut = false;
        }

        if (this.adminPlacementDB.amendsIEPReportingLEA) {
          this.showPreviousIepInfo = true;
        }
        else {
          this.showPreviousIepInfo = false;
        }

        this.adminPlacementDB.annualDue = this.adminPlacementDB.annualDue == null ? null : new Date(this.adminPlacementDB.annualDue);
        this.adminPlacementDB.lastAnnualDate = this.adminPlacementDB.lastAnnualDate == null ? null : new Date(this.adminPlacementDB.lastAnnualDate);
        this.adminPlacementDB.lastTriennial = this.adminPlacementDB.lastTriennial == null ? null : new Date(this.adminPlacementDB.lastTriennial);
        this.adminPlacementDB.participantsAdministratorDesigneeDate = this.adminPlacementDB.participantsAdministratorDesigneeDate == null ? null : new Date(this.adminPlacementDB.participantsAdministratorDesigneeDate);
        this.adminPlacementDB.participantsOtherDate = this.adminPlacementDB.participantsOtherDate == null ? null : new Date(this.adminPlacementDB.participantsOtherDate);
        this.adminPlacementDB.participantsParentGuardianDate = this.adminPlacementDB.participantsParentGuardianDate == null ? null : new Date(this.adminPlacementDB.participantsParentGuardianDate);
        this.adminPlacementDB.participantsTeacherDate = this.adminPlacementDB.participantsTeacherDate == null ? null : new Date(this.adminPlacementDB.participantsTeacherDate);
        this.adminPlacementDB.triDueDate = this.adminPlacementDB.triDueDate == null ? null : new Date(this.adminPlacementDB.triDueDate);
        this.adminPlacementDB.verifiedDate = this.adminPlacementDB.verifiedDate == null ? null : new Date(this.adminPlacementDB.verifiedDate);
        this.isDataLoaded = true;

        if (this.adminPlacementDB.applicationErrors != '') {
          let errorMessage: Message = { severity: 'error', summary: 'Correct error', detail: this.adminPlacementDB.applicationErrors }; 
          this.addMessage(errorMessage);
        }
        this.showSpinner = false;
      },
        err => {
          console.error(err);
          this.showSpinner = false;
        }
      );

    }
  }

  LoadLookupValues() {
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.Disability]).subscribe((res: ILookupBase[]) => {
      this.lookupDisabilityList = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);
    },
     err => console.error(err)
    );

    this.lookupDegreeOfSupportList = [
      { value: null, label: '[Select One]' },
      { value: 1, label: 'Mild to Moderate Support Needs' },
      { value: 2, label: 'Extensive Support Needs' }
    ]

    //services
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.SPEDService]).subscribe((res: ILookupBase[]) => {
      this.spedServiceList = res.map(o => {
        return {
          value: o.value,
          label: o.value + " " + o.label,
          shortText: o.shortText,
          updatedOn: o.updatedOn,
        };
      });
      this.lookupServiceList = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(this.spedServiceList);;

      //to avoid race conditions including disabled is nested; this method should propably not bein nesting inside loading the form
      this._lookupService.getLookupArray(this._baseUrl + `api/Lookup/GetLookupList?lookupTableName=${LookupTypeEnum[LookupTypeEnum.SPEDServiceIncludeDisabled]}`).subscribe(
        (res: ILookupBase[]) => {
          this.spedServiceListIncludeDisabled = res.map(o => {
            return {
              value: o.value,
              label: o.value + " " + o.label,
              shortText: o.shortText,
              updatedOn: o.updatedOn,
            };
          });

          if (this.services) {
            let existingServiceValues = this.services.map(s => s.serviceId);
            let lookupServiceValues = this.spedServiceList.map(l => l.value);
            existingServiceValues.forEach((item: string) => {
              if (lookupServiceValues.indexOf(item) === -1) {

                //get disabled item
                let disabledService = this.spedServiceListIncludeDisabled.find(s => s.value === item);
                if (disabledService) {
                  this.lookupServiceList.push({
                    value: disabledService.value,
                    label: disabledService.label,
                    shortText: disabledService.shortText,
                    updatedOn: disabledService.updatedOn
                  });
                  lookupServiceValues.push(disabledService.value); //avoid duplicate additions
                }
              }
            })

            this.lookupServiceList = [...this.lookupServiceList];
          }
        }
      );
    },
      err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ServiceDuration]).subscribe((res: ILookupBase[]) => {
      this.lookupServiceDurationList = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);;
    },
      err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ServiceLocation]).subscribe((res: ILookupBase[]) => {
      this.lookupServiceLocationList = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);;

      //to avoid race conditions including disabled is nested; this method should propably not bein nesting inside loading the form
      this._lookupService.getLookupArray(this._baseUrl + `api/Lookup/GetLookupList?lookupTableName=${LookupTypeEnum[LookupTypeEnum.ServiceLocationIncludeDisabled]}`).subscribe(
        (res: ILookupBase[]) => {
          this.lookupServiceLocationListWithDisabled = res;

          if (this.services) {
            let existingLocationValues = this.services.map(s => s.location);
            let lookupLocationValues = this.lookupServiceLocationList.map(l => l.value);
            existingLocationValues.forEach((item: string) => {
              if (lookupLocationValues.indexOf(item) === -1) {

                //get disabled item
                let disabledLocation = this.lookupServiceLocationListWithDisabled.find(ld => ld.value = item);
                if (disabledLocation) {
                  this.lookupServiceLocationList.push({ value: disabledLocation.value, label: disabledLocation.label, shortText: disabledLocation.shortText, updatedOn: disabledLocation.updatedOn });
                  lookupLocationValues.push(disabledLocation.value); //avoid duplicate additions
                }
              }
            })

            this.lookupServiceLocationList = [...this.lookupServiceLocationList];
          }
        }
      );
    },
      err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ServiceFrequency]).subscribe((res: ILookupBase[]) => {
      this.lookupServiceFrequencyList = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);;
    },
      err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.Curriculum]).subscribe((res: ILookupBase[]) => {
      this.lookupCurriculumList = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);
    },
      err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ServiceIndividualGroup]).subscribe((res: ILookupBase[]) => {
      this.lookupServiceIndividualGroupList = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);;

      //to avoid race conditions including disabled is nested; this method should propably not bein nesting inside loading the form
      this._lookupService.getLookupArray(this._baseUrl + `api/Lookup/GetLookupList?lookupTableName=${LookupTypeEnum[LookupTypeEnum.ServiceIndividualGroupIncludeDisabled]}`).subscribe(
        (res: ILookupBase[]) => {
          this.lookupServiceIndividualGroupListWithDisabled = res;

          if (this.services) {
            let existingIndividualGroupValues = this.services.map(s => s.individualGroup);
            let lookupIndividualGroupValues = this.lookupServiceIndividualGroupList.map(l => l.value);
            existingIndividualGroupValues.forEach((item: string) => {
              if (lookupIndividualGroupValues.indexOf(item) === -1) {

                //get disabled item
                let disabledIndividualGroup = this.lookupServiceIndividualGroupListWithDisabled.find(ld => ld.value = item);
                if (disabledIndividualGroup) {
                  this.lookupServiceIndividualGroupList.push({ value: disabledIndividualGroup.value, label: disabledIndividualGroup.label, shortText: disabledIndividualGroup.shortText, updatedOn: disabledIndividualGroup.updatedOn });
                  lookupIndividualGroupValues.push(disabledIndividualGroup.value); //avoid duplicate additions
                }
              }
            })

            this.lookupServiceIndividualGroupList = [...this.lookupServiceIndividualGroupList];
          }
        }
      );
    },
      err => console.error(err)
    );


    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.HowVerified]).subscribe((res: ILookupBase[]) => {
      this.howVerifiedList = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);;
    },
      err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CALPADSMeetingType]).subscribe((res: ILookupBase[]) => {
      this.calpadsMeetingTypeList = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);;
    },
      err => console.error(err)
    );

  }

  newRow() {
    this.services.push({
      id: 0,
      localStudentId: this.adminPlacementDB.spedStudentDemographic.localStudentId,
      serviceId: null,
      duration: null,
      location: null,
      frequency: null,
      individualGroup: null,
      pushInPullOut: '',
      startDate: this.serviceStartDate,
      endDate: null,
      removed: null,
      offerOfFapeStartDate: this.adminPlacementDB.meetingDate,
      offerOfFapeEndDate: this.adminPlacementDB.iepMeetingToBeConducted30DaysBy,
      offerOfFapeEndDateString: this.adminPlacementDB.iepMeetingToBeConducted30DaysBy,
      serviceDuration: null,
      sortOrder: null,
      starIepPage1_Id: null,
      iPAddress: null,
      updatedOn: null,
      rowNumber: this.rowNum++,
    })
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  loadUnLock(action) {
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;

    this.globals.editMode = true;
  }

  saveStudentServices() {
    this.adminPlacementDB.serviceInformationList = this.services.map(o => {
      return {
        id: o.id,
        localStudentId: o.localStudentId,
        starSpecialEducationService_Id: parseInt(o.serviceId),
        duration: parseInt(o.duration),
        location: parseInt(o.location),
        frequency: parseInt(o.frequency),
        individualGroup: parseInt(o.individualGroup),
        pushInPullOut: o.pushInPullOut,
        startDate: this.serviceStartDate,
        endDate: null,
        removed: o.removed,
        offerOfFapeStartDate: o.offerOfFapeStartDate,
        offerOfFapeEndDate: new Date(o.offerOfFapeEndDateString),
        serviceDuration: o.serviceDuration,
        sortOrder: o.sortOrder,
        starIepPage1_Id: o.starIepPage1_Id,
        iPAddress: o.iPAddress,
        updatedOn: o.updatedOn,
      };
    });
  }

  //Save the
  save(action) {
    this.clearMessages();
    this.saveClicked = true;
    this.showSpinner = true;
    this.saveStudentServices()
    this.scrollToTop();

    //update values
    this._adminPlacementService.insertUpdateAdminPlacement(this.adminPlacementDB).subscribe((res: IAdminPlacement) => {
      let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id?.toString() }
      this.addMessage(successMessage);
      if (action == 'Close') {
        this.globals.editMode = false;
        this.loadUnLock("UnLock");
        this.passedPrintSignatureValidation = false;
      }
      this.saveClicked = false
      this.showSpinner = false;
      this.LoadAdminPlacementDetails();
      this.validateAP();
      
      this._dashboardDocumentService.get(this._baseUrl + 'api/DashboardDocument/' + this.adminPlacementDB.localStudentId).subscribe((res: IDashboardDocument[]) => {
        this._myGlobals.dashboardDocumentResults = res
          , console.log(this._myGlobals.dashboardDocumentResults)
          , this._myGlobals.documentDashboardIsVisible = false
          , this._myGlobals.initialIepInfoIsVisible = false;
      },
        err => console.error(err)
      );

      if (this.adminPlacementDB.statusId == 3) {
        this._studentService.get(this._baseUrl + 'api/Student/' + this.adminPlacementDB.localStudentId).subscribe((res: ISelectedStudent) => {
          this._myGlobals.setSelectedStudent(res),
            this._myGlobals.studentSearchIsVisible = false,
            this._myGlobals.initialIepInfoIsVisible = false,
            console.log(this._myGlobals.selectedStudent)
        },
          err => console.error(err)
        );
      }
    },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
          this.showSpinner = false;
        }
      )
  }

  RefreshStudentDemographicsAndContactsData() {
    this.controlSpinner(true, this._aeriesRefreshSpinnerMessage);
    this._dashboardDocumentService.refreshAPSpedStudentDemographicsAndContactsFromAeries(this.adminPlacementDB.id).subscribe((res: ISpedStudentDemographics) => {
      this.controlSpinner(false, '');
      this.LoadAdminPlacementDetails();
    },
      err => {
        console.error(err);
        this.controlSpinner(false, '');
      }
    );
  }

  controlSpinner(visible: boolean, spinnerWhileMessage: string) {
    this.showRefreshSpinner = visible;
    this._spinnerWhileMessage = spinnerWhileMessage;
  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock("UnLock");
    this.LoadAdminPlacementDetails();
    this.passedPrintSignatureValidation = false;
  }

  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'ShowCustomWaterMark', parameterValue: 'False' },
      { parameterName: 'CustomWatermarkText', parameterValue: '' },
      { parameterName: 'AdministrativePlacementId', parameterValue: this.adminPlacementDB.id.toString() },  
    );

    if (this.adminPlacementDB.studentAge) {
      this.reportParamArray.push({ parameterName: 'StudentAge', parameterValue: this.adminPlacementDB.studentAge?.toString() })
    }
    else if (this.adminPlacementDB.spedStudentDemographic != null || this.adminPlacementDB.spedStudentDemographic != undefined) {
      this.reportParamArray.push({ parameterName: 'StudentAge', parameterValue: this.adminPlacementDB.spedStudentDemographic.ageOnMeetingDate?.toString() })
    }
  }

  validateAPForPrintSignature() {
    this.passedPrintSignatureValidation = false;
    this.clearMessages();
    this.validateAP();
    
  }

  validateAP() {
    this._adminPlacementService.validateAdministrativePlacement(this.adminPlacementDB.id)
      .subscribe((res: string[]) => {
        for (var item of res) {
          let errorMessage: Message = { severity: 'error', summary: 'Validation Error', detail: item };
          this.addMessage(errorMessage);
        }
        if (this.errorMessages.length == 0) {
          this.passedPrintSignatureValidation = true;
        }
      },
        err => console.error(err)
      );
  }

  printSignature() {
    if (confirm('You are requesting to change the status of this Administrative Placement to Print Signature.  Once changed, no further changes are allowed.  Are you sure that you want to proceed?')) {
      this.adminPlacementDB.statusId = 2;
      this.save('Close');
    }
  }

  official() {
    if (confirm('You are requesting to change the status of this Administrative Placement to Official.  Once changed, no further changes are allowed.  Are you sure that you want to proceed?')) {
      this.adminPlacementDB.statusId = 3;
      this.save('Close');

      this._studentService.get(this._baseUrl + 'api/Student/' + this._myGlobals.selectedStudent.localStudentId).subscribe((res: ISelectedStudent) => {
        this._myGlobals.setSelectedStudent(res),
          this._myGlobals.studentSearchIsVisible = false,
          this._myGlobals.initialIepInfoIsVisible = false,
          console.log(this._myGlobals.selectedStudent)
      },
        err => console.error(err)
      );

    }
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommonOverload('AdministrativePlacement', this.reportParamArray, false, true);
  }


  printSpanish() {
    //this.populateReportParameters();
    //this.printFormCommon('AdministrativePlacement_Spanish', this.reportParamArray);
  }

}
